// Import package components
import { useMemo, useEffect, useContext, useState, useRef } from "react";

// Import base components
import { Image } from "uikit-react";
import { AppContexts } from "../../../providers";

const Responses = ({ onChange }) => {
  const {
    templatesCtx: { get, templates },
  } = useContext(AppContexts.TemplatesContext);

  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  const responses = useMemo(() => {
    if (Object.keys(templates).length === 0) return [];
    if (!templates.saved_responses) return [];
    return templates.saved_responses
      .slice()
      .sort((prev, next) => prev.name.localeCompare(next.name));
  }, [templates]);

  const filteredResponses = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return responses;

    return responses.filter((r) => {
      const name = (r.name || "").toLowerCase();
      const body = (r.response || "").toLowerCase();
      return name.includes(q) || body.includes(q);
    });
  }, [responses, query]);

  useEffect(() => {
    get(["saved_responses"]);
  }, []);

  return (
    <div>
      <button uk-tooltip="Click to select from a Saved Response" type="button">
        <Image src="/images/reply-with.svg" className="msg-icon" />
      </button>

      <div
        data-uk-dropdown="mode: click"
        id="messages-response"
        // optional: keep dropdown from being too narrow
        style={{ minWidth: 360 }}
      >
        <div style={{ padding: "12px 0 0 0" }}>
          <input
            ref={inputRef}
            className="uk-input uk-form-small"
            type="text"
            placeholder="Search saved responses..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        <ul className="uk-nav uk-dropdown-nav tags-selector">
          {filteredResponses.length > 0 ? (
            filteredResponses.map((response, index) => (
              <li
                key={response.id ?? `${response.name}-${index}`}
                className="messages-li"
                uk-tooltip="Click to Insert"
                onClick={() => onChange(response.response)}
              >
                <div className="semi-bold-font">{response.name}</div>
                <label uk-line-clamp="lines: 1">{response.response}</label>
              </li>
            ))
          ) : responses.length > 0 ? (
            <div style={{ padding: "20px 25px" }}>
              No matches for “{query}”.
            </div>
          ) : (
            <div style={{ padding: "30px 25px" }}>
              No saved responses. <a href="/saved-responses">Add Now.</a>
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Responses;